import request from './request'

/**
 * 提交问卷
 * @param {Object} data {survey_type:"pre"/"post", content:"JSON字符串答题"}
 */
export function apiSurveySubmit(data) {
    return request({
        url: '/survey/submit',
        method: 'post',
        data
    })
}

/**
 * 获取当前用户问卷完成状态
 */
export function apiGetSurveyStatus() {
    return request({
        url: '/survey/getStatus',
        method: 'get'
    })
}